module.exports = __webpack_public_path__ + "static/img/social_banner_h5.12c29ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/social_banner_h5.png
// module id = j7GA
// module chunks = 34